module.exports = __webpack_public_path__ + "static/media/no-image_White.27df3de1.png";